<script>
  import { afterUpdate, onDestroy, onMount } from 'svelte';
  import { External, M } from '../../external';
  import { getVideoService, postVideoService, deleteVideoService } from '../static';
  import Checkbox from '../../Common/Checkbox.svelte';
  import Loader from '../../Common/Loader.svelte';

  export let video = {};

  let categories = video.categories ? video.categories : [];
  let allCategories = [];
  let isCategoriesReordered = false;
  let loadingCategories = true;
  let updateTrigger = 0;
  let sortableInstance;

  onMount(async () => {
    loadingCategories = true;
    allCategories = await getVideoService('/categories');
    loadingCategories = false;
  });

  afterUpdate(() => {
    // Initialize or refresh sortable
    if (sortableInstance) {
      sortableInstance.destroy();
    }

    sortableInstance = External.$('#selectedVideoCategoriesVideoProperty').sortable({
      update: () => {
        isCategoriesReordered = true;
      }
    });
  });

  onDestroy(() => {
    if (sortableInstance) {
      if (isCategoriesReordered) {
        const reorderedCategories = sortableInstance
          .sortable('toArray', { attribute: 'data-video-category' })
          .filter((category) => category !== '');

        postVideoService('/category/all', reorderedCategories);
      }

      sortableInstance.destroy();
    }

    video.categories = categories;
  });

  function openAddCategoryPopup() {
    External.Tools.showWindow({
      title: M.CREATE_CATEGORY,
      markup:
        `<div class="popup-widget-wrapper"><input id="globalVideoCategoryInp" type="text" name="videoCategory" placeholder="${M.ADD_VIDEO_CATEGORY}"></div>`,
      width: 400,
      isModal: true,
      withDarkBackground: true,
      buttons: [
        External.Button(M.SAVE, External.Button.CLASS_MIDDLE_BLUE, (popup, context) => {
          const category = context.find('#globalVideoCategoryInp').val();
          addCategory(category);
          popup.close();
        }),
        External.Button.MIDDLE_CLOSE
      ]
    });
  }

  const addCategory = async (name) => {
    if (!name) return;
    loadingCategories = true;

    const categoryId = await postVideoService('/category', null, { category: name });

    categories = [...categories, {categoryId, name}];
    allCategories = [...allCategories, {categoryId, name}];
    loadingCategories = false;
  };

  const deleteCategory = (category) => {
    External.Tools.prompt(M.DELETE, External.format(M.DEL_CONFIRM_EXT, 'ext', category.name), async () => {
      loadingCategories = true;
      await deleteVideoService('/category', { category: category.categoryId });
      allCategories = allCategories.filter((item) => item.categoryId !== category.categoryId);
      categories = categories.filter((item) => item.categoryId !== category.categoryId);
      loadingCategories = false;
    });
  };

  const toggleSelectCategory = (isChecked, category) => {
    if (isChecked) {
      categories = [...categories, category];
    } else {
      categories = categories.filter((item) => item.categoryId !== category.categoryId);
    }
    updateTrigger += 1;
  }

  const hasCategory = (category) => {
    return categories.some(item => item.categoryId === category.categoryId);
  }
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center">
    <a on:click={openAddCategoryPopup} class="middle-button blue with-icon inline-block f-none"> {M.ADD_CATEGORY} </a>
  </div>

  <div class="f-left t-center mb-25 col20">
    {#key updateTrigger}
      {#if loadingCategories}
        <Loader />
      {:else}
        <div id="selectedVideoCategoriesVideoProperty">
          {#each allCategories as category, i}
            <div class="col20 mt-5 f-left gray-section product-select-wrapper" data-video-category={category.categoryId}>
              <div class="popup-input-wrapper flex align-center space-between">
                <div class="flex align-center">
                  <span class="move-icon button-tooltip f-left" data-tooltip="simpleMove"></span>
                  <Checkbox
                    data={hasCategory(category)}
                    onChange={(isChecked) => toggleSelectCategory(isChecked, category)}
                    label={category.name}
                    clz="ml-10 mb-0 f-left" />
                </div>
                <a
                  on:click={() => deleteCategory(category)}
                  data-tooltip="simpleDelete"
                  class="f-right delete delete-icon modify button-tooltip light-gray-icon circle-effect remove-from-videos">
                  <i class="material-icons-outlined">delete</i>
                </a>
              </div>
            </div>
          {/each}
        </div>
      {/if}
    {/key}
  </div>
</div>
